import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { doc, getDoc, getDocs, collection } from 'firebase/firestore/lite';

import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSM from '../../components/Footers/FooterSmall.js';
import NftDetailsComponent from '../../components/NftDetails/index';
import { firebaseFireStore } from '../../config/firebaseFirestore.js';
import NftSchema from '../../schema/NftSchema';
import { getUserName } from '../../services/common-query.js';

function NftDetailPage(props) {
  const router = useRouter();
  const { nftId } = router.query;

  const [nftData, setnftData] = useState(null);
  const [musicData, setmusicData] = useState(null);
  const [isAdmin, setisAdmin] = useState(false);

  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const isUserDataFetched = useSelector(
    (state) => state.authReducer.isUserDataFetched,
  );

  // url
  useEffect(() => {
    router.beforePopState((cb) => {
      if (cb.as === '/discover') {
        window.location.href = cb.as;
        return false;
      }
      return true;
    });
  }, []);

  useEffect(() => {
    if (props.nftData) {
      console.log('nftdata exits');
      setnftData(props.nftData);
    }
  }, [props.nftData]);

  useEffect(() => {
    if (props.musicData) {
      setmusicData(props.musicData);
    }
  }, [props.musicData]);

  useEffect(() => {
    if (!props.nftData && props.mounted && isUserDataFetched) {
      if (isUserDataFetched && userDataRedux) {
        //checking if user is owner of nft or admin
        checkUserState();
      } else {
        router.push('/discover');
      }
    }
  }, [props.nftData, props.mounted, userDataRedux, isUserDataFetched]);

  useEffect(() => {
    if (userDataRedux?.uid) {
      adminStateCheck();
    }
  }, [userDataRedux]);

  const checkUserState = async () => {
    const summary = await getDoc(doc(firebaseFireStore, 'musicartNfts', nftId));

    if (
      summary.data() &&
      summary.data().usersId &&
      userDataRedux.uid &&
      summary.data().usersId.includes(userDataRedux.uid)
    ) {
      //user owns nft
      console.log('is owner');
      getNftData(summary.data());
    } else {
      console.log('is not owner');
      // check admin state
      let adminExit = await adminStateCheck();
      if (adminExit) {
        console.log('is admin');
        getNftData(summary.data());
      } else {
        console.log('not admin');
        router.push('/discover');
      }
    }
  };

  const getNftData = async (data) => {
    let lNftData = { ...data };
    if (!lNftData) {
      const summary = await getDoc(
        doc(firebaseFireStore, 'musicartNfts', nftId),
      );
      if (!summary.data()) {
        router.push('/discover');
      }
      lNftData = { ...summary.data() };
    }

    const details = await getDoc(
      doc(firebaseFireStore, 'musicartNfts', nftId, 'nftData', 'details'),
    );

    lNftData = {
      ...lNftData,
      ...details.data(),
    };

    let dbRef = await getDoc(
      doc(firebaseFireStore, 'musicartArtists', lNftData.artistId),
    );
    let artistData = { ...dbRef.data(), artistId: dbRef.id };

    setnftData({ ...lNftData });
    setmusicData({ ...artistData });
  };

  const adminStateCheck = async () => {
    return await getDoc(doc(firebaseFireStore, 'admin', 'adminList')).then(
      (doc) => {
        if (
          doc.exists &&
          doc.data() &&
          doc.data().admins.includes(userDataRedux.uid)
        ) {
          //user is admin
          setisAdmin(true);
          return true;
        }
        return false;
      },
    );
  };

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href={`https://musicart.io/nft/${props.nftId}`} />
      </Head>

      <div className="relative">
        <Navbar transparent />
        {nftData && (
          <NftDetailsComponent
            data={nftData}
            musicData={musicData}
            bsvRate={props.bsvRate}
            isAdmin={isAdmin}
          />
        )}
        <Footer />
        <FooterSM />
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  const { nftId } = context.params;
  console.log('server side data fetch');

  const summary = await getDoc(doc(firebaseFireStore, 'musicartNfts', nftId));

  console.log('data fetched');

  var data = null;
  var artistData = null;

  if (
    summary.data() &&
    summary.data().activeInMarketPlace &&
    summary.data().adminState === 'ACCEPT'
  ) {
    const details = await getDoc(
      doc(firebaseFireStore, 'musicartNfts', nftId, 'nftData', 'details'),
    );

    data = {
      ...summary.data(),
      ...details.data(),
    };

    let dbRef = await getDoc(
      doc(firebaseFireStore, 'musicartArtists', data.artistId),
    );
    artistData = { ...dbRef.data(), artistId: dbRef.id };
  }

  //bsvrate
  let rate = null;
  let bsvData = await getDoc(doc(firebaseFireStore, 'exchangeRates', 'bsv'));
  if (bsvData.exists) {
    if (bsvData.data() && bsvData.data().rate) {
      rate = Number(bsvData.data().rate);
    }
  }

  return {
    props: {
      nftData: JSON.parse(JSON.stringify(data)),
      musicData: JSON.parse(JSON.stringify(artistData)),
      nftId: JSON.parse(JSON.stringify(nftId)),
      bsvRate: rate,
      mounted: true,
    },
  };
}

export default NftDetailPage;
